import { TMenuLeaf } from '../components/types';
import {
    CONVERSATIONS_AUTH,
    CATALOGUE_AUTH,
    CHATBOT_AUTH,
    WARBOX_CONVERSATIONS_AUTH,
} from 'src/constants/permissions';

export const CONVERSATIONS_MENU: TMenuLeaf[] = [
    {
        title: 'Navbar.Conversations',
        path: '/conversations',
        permission: CONVERSATIONS_AUTH,
    },
    {
        title: 'Navbar.Conversations',
        path: '/omnichannel',
        permission: WARBOX_CONVERSATIONS_AUTH,
        label: 'new',
    },
    {
        title: 'Documents.Catalogue',
        path: '/management/catalogue',
        permission: CATALOGUE_AUTH || CONVERSATIONS_AUTH,
    },
    {
        title: 'Plugins.chatBot',
        path: '/management/chatbot',
        permission: CHATBOT_AUTH,
    },
];
